import { createSelector } from "reselect";
import { validators, validate } from "../helpers/validationHelpers";
import { EMAIL, CONFIRM_EMAIL } from "../consts/formKeys";

const configSelector = state => state.config;
const dataSourceSelector = state => state.dataSource;
const detailSelector = state => state.personalDetail;
const waitingListSelector = state => state.waitingList;

const getState = (config, dataSource, personalDetail, waitingList) => {
  const errors = Object.keys(validators).reduce((err, key) => {
    const rules = validators[key];
    let errorMessage = "";
    if (key === CONFIRM_EMAIL) {
      errorMessage = validate(
        rules,
        personalDetail[key],
        personalDetail[EMAIL]
      );
    } else {
      errorMessage = validate(rules, personalDetail[key]);
    }
    if (errorMessage) {
      return { ...err, [key]: errorMessage };
    }
    return err;
  }, {});
  return {
    requireWaitingList: waitingList.required,
    mobileHintDescription: config.mobileHintDescription,
    customerConfirmationPolicy: config.customerConfirmationPolicy,
    anyPractitioner: config.preSelectPractitioner === "ANY",
    useRecaptcha: config.reCaptchaEnabled,
    isMedibank: config.tenant.toLowerCase() === "medibank",
    showMembershipCardFields:
      personalDetail.healthFund === config.MedibankFundId,
    healthFunds: dataSource.healthFunds,
    customFields: dataSource.customFields,
    personalDetail,
    errors
  };
};

const personalDetailSelector = createSelector(
  configSelector,
  dataSourceSelector,
  detailSelector,
  waitingListSelector,
  getState
);

export { personalDetailSelector };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/selectors/personalDetailSelector.js